import type { IExternalUTMS, IUTMS } from '../types/utm.types'

export const useUtm = (props: IExternalUTMS): IUTMS => {
  const route = useRoute()

  return {
    utm: '',
    utmMedium: route.query.utm_medium?.toString() ?? '',
    utmSource: route.query.utm_source?.toString() ?? '',
    utmCampaign: route.query.utm_campaign?.toString() ?? '',
    utmTerm: route.query.utm_term?.toString() ?? '',
    utmContent: route.query.utm_content?.toString() ?? '',
    utmAdset: route.query.utm_adset?.toString() ?? '',
    utmAdGroup: route.query.utm_adgroup?.toString() ?? '',
    webSource: route.query.web_source?.toString() ?? 'benefitsystems.pl',
    formId: route.query.formId?.toString() ?? props.utmSource,
  }
}
